<template>
  <div>
    <a-drawer
      title="系统抽签"
      placement="right"
      width="50%"
      :closable="false"
      :visible="modalVisible"
      @close="() => (modalVisible = false)"
    >
      <a-tabs v-model="packIndex" :style="{ height: '30vw' }" @change="tabsChange">
        <a-tab-pane v-for="(item, i) in resultData" :key="i">
          <div class="tab-a" slot="tab">{{ item.bidPacks.extras.title }}</div>
          <div style="display: flex; justify-content: space-between" class="mt-1">
            <div class="pl" v-if="!item.isDeal && prizes.length != 0">
              <div
                v-for="(items, index) in item.jiaResultList"
                :key="index"
                style="display: flex; margin-top: 5px"
              >
                <div :style="{ '--bg': getColor(`''*${index}`) }" class="pl-c"></div>
                <div style="margin-left: 2px">{{ items.supplierName }}</div>
              </div>
            </div>
            <div v-if="!item.isDeal && prizes.length != 0">
              <LuckyWheel
                :ref="'myLucky_' + item.bidPacks.id"
                width="350px"
                height="350px"
                :prizes="prizes"
                :blocks="blocks"
                :buttons="buttons"
                @end="endCallBack"
              />
            </div>
            <div v-else class="mt-5">{{ item.bidPacks.extras.title }}已完成抽签</div>
          </div>
          <div v-if="!item.isDeal && prizes.length == 0">
            {{ item.bidPacks.extras.title }}没有相同的报价出现
          </div>
          <div class="mt-3">
            经系统抽签确定的成交者为：<span style="color: red">
              {{ item.trader.supplierName }}
            </span>
            &nbsp;&nbsp;成交金额为：<span style="color: red">
              {{ item.trader.price }}元
            </span>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-drawer>
    <div>
      <CompetitiveResultChat
        ref="chat"
        :packId="packId"
        :resultDataLength="resultData.length"
        @onMessageResult="onMessageResultReceived"
      ></CompetitiveResultChat>
    </div>
  </div>
</template>

<script>
import CompetitiveResultChat from "./CompetitiveResultChat";
export default {
  name: "CompetitiveResultDraw",
  // props: ["packId", "jingjiaWay", "packIndex", "packs"],
  components: {
    CompetitiveResultChat,
  },
  data() {
    return {
      modalVisible: false,
      // dealRule: "1",
      packIndex: 0,
      packId: "",
      resultData: [
        {
          bidPacks: {
            extras: "",
          },
          isDeal: false,
          trader: {
            supplierName: "",
            price: null,
          },
        },
      ],
      //转盘数据
      blocks: [{ padding: "10px", background: "#869cfa" }],
      buttons: [
        { radius: "40%", background: "#617df2" },
        { radius: "35%", background: "#afc8ff" },
        {
          radius: "30%",
          background: "#869cfa",
          pointer: true,
          fonts: [{ text: "中签者", top: "-10px" }],
        },
      ],
      prizes: [],
      jiaResultList: [],
      socketUrl: process.env.VUE_APP_API_SERVER + "/webSocket",
      socket: "",
      stompClient: null,
      trader: { supplierName: "", price: 0 },
    };
  },
  created() {
    this.initmodel();
    // this.initWebSocket(); //初始化webSocket
  },
  /*   computed: {
    traderComputed() {
      return function (jingjiaResult, type) {
        let priceProcesses = jingjiaResult.bidPriceProcesses;
        //返回中签的供应商数据
        if (this.bidProcess.xtcq) {
          if (priceProcesses != undefined) {
            for (let index = 0; index < priceProcesses.length; index++) {
              const element = priceProcesses[index];
              if (element.state == "1") {
                if (type == 0) {
                  return element.supplier_name;
                } else {
                  return element.price;
                }
              }
            }
          }
        }
      };
    },
  }, */
  methods: {
    initmodel() {
      this.initPrizes();
    },
    tabsChange(key) {
      this.packIndex = key;
      this.packId = this.resultData[key].bidPacks.id;
      this.initPrizesResult(this.resultData[key].jiaResultList);
    },
    async initPrizes() {
      let that = this;
      let res = await this.$http.get(
        "/api/v1/supplier/result/get_draw.json?projectId=" + this.$route.query.projectId
      );
      that.packId = res.result[that.packIndex].bidPacks.id;
      that.resultData = res.result;
      that.initPrizesResult(res.result[that.packIndex].jiaResultList);
    },

    initPrizesResult(prizesResult) {
      let that = this;
      that.jiaResultList = prizesResult;
      that.prizes = [];
      if (prizesResult.length == 2) {
        for (let i = 0; i < 2; i++) {
          that.pushPrizes(prizesResult);
        }
      } else {
        that.pushPrizes(prizesResult);
      }
    },
    pushPrizes(prizesResult) {
      let that = this;
      for (let j = 0; j < prizesResult.length; j++) {
        that.prizes.push({
          background: that.getColor(`''*${j}`),
          supplierId: prizesResult[j].supplierId,
          price: prizesResult[j].price,
          fonts: [
            {
              text: "",
              title: prizesResult[j].supplierName,
              lengthLimit: "50%",
              lineClamp: 3,
            },
          ],
        });
      }
    },
    // 点击抽奖按钮会触发star回调
    startCallback(packId) {
      let that = this;
      const refMyLucky = this.$refs["myLucky_" + packId];
      // 调用抽奖组件的play方法开始游戏
      if(refMyLucky!=undefined) {
        refMyLucky[0].play();
      }
    },
    // 抽奖结束会触发end回调
    endCallBack(prize) {
      console.log("cg", prize);
      setTimeout(() => {
        this.resultData[this.packIndex].trader = {
          supplierName: prize.fonts[0].title,
          price: prize.price,
        };
      }, 1000);
    },
    /*   initWebSocket() {
      //初始化websocket操作
      this.socket = new SockJS(this.socketUrl);
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.debug = null; // 关闭浏览器控制台中 日志打印
      this.stompClient.connect(
        {},
        (frame) => {
          this.successCallback(); //连接成功时，回调
        },
        (error) => {
          //连接失败时回调
          this.reconnect(this.socketUrl, this.successCallback); // 此处调用重连方法
        }
      );
    }, */
    /*  reconnect(socketUrl, successCallback) {
      //断开重连使用定时器定时连接服务器
      let connected = false;
      this.reconInv = setInterval(() => {
        this.socket = new SockJS(socketUrl);
        this.stompClient = Stomp.over(this.socket);
        this.stompClient.connect(
          {},
          (frame) => {
            clearInterval(this.reconInv); // 连接成功，清除定时器
            connected = true;
            successCallback();
          },
          (error) => {
            // this.$message.warning("服务重连中,请勿操作!")
            //   this.sysWarning("服务重连中,请勿操作!");
          }
        );
      }, 5000);
    }, */
    /*  successCallback() {
      // 连接成功
      let packId = this.packId;
      this.stompClient.subscribe("/topic/draw/" + packId, this.onMessageReceived);
    }, */
    onMessageResultReceived(payload) {
      // 接收到消息并对消息做处理
      // console.log("初始化websocket成功");
      var list = JSON.parse(payload.body);
      var dataList = list;
      // this.initPrizes()
      if (dataList.reStart) {
        this.initPrizes();
        this.resultData[dataList.packIndex].isDeal = false;
        this.$emit("reSatrtDraw")
      } else {
        if (dataList.start == true) {
          let secondsToGo = 10;
          /*  this.$notification["info"]({
            message: "温馨提示",
            description: `系统将在10秒后自动开始抽签`,
            duration: 10,
          }); */
          // const interval = setInterval(() => {
          //   secondsToGo -= 1;
          // }, 1000);
          // setTimeout(() => {
          //   clearInterval(interval);
            this.startCallback(dataList.packsId);
          // }, secondsToGo * 1000);
        } else {
          const refMyLucky = this.$refs["myLucky_" + dataList.packsId];
          let index = this.randomProcessing(dataList);
          if(refMyLucky){
            refMyLucky[0].stop(index);
          }
          // console.log(index);
        }
      }
    },
    //后端随机抽取到的供应商然后跟prizes的supplierId进行匹配获取prizes的索引值
    randomProcessing(dataList) {
      let supplierId = dataList.priceResult.supplier_id;
      let arr = [];
      for (let i = 0; i < this.prizes.length; i++) {
        if (this.prizes[i].supplierId == supplierId) {
          arr.push(i);
        }
      }
      // console.log(arr);
      return arr[parseInt(Math.random() * arr.length)];
    },
    getColor(value) {
      return "#" + this.getHashCode(value).toString(16).substr(0, 6);
    },
    getHashCode(str) {
      var hash = 1315423911,
        i,
        ch;
      for (i = str.length - 1; i >= 0; i--) {
        ch = str.charCodeAt(i);
        hash ^= (hash << 5) + ch + (hash >> 2);
      }
      return hash & 0x7fffffff;
    },
  },
  beforeDestroy() {
    clearInterval(this.reconInv);
    this.drawStompClient.disconnect();
  },
};
</script>

<style lang="less" scoped>
.pl {
  display: flex;
  flex-direction: column;
  height: 20vw;
  overflow-y: auto;
}
.pl-c {
  height: 20px;
  width: 20px;
  background-color: var(--bg);
}
/deep/ .ant-drawer-body {
  padding-top: 0;
}
</style>
